import styled from 'styled-components';
import { FlexColumn } from '../../../styled/common';
import { Typography } from '../../ui/Typography';
import { tagStyles } from '../../ui/Typography/styles';
import { Breakpoints } from '../../../styled/constants';

export const ApartmentsFilterContainer = styled(FlexColumn)`
  gap: 20px;
  padding: 30px 0;
  background-color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 14px;
`;

export const ApartmentsFilterTitle = styled(Typography)`
  display: block;
  padding: 0 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    ${tagStyles.title_3_desc};
  }
`;

export const ApartmentsFilterContent = styled.div`
  padding: 0 15px;

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px;
  }
`;

export const PaginationWrapper = styled.div`
  padding-top: 10px;
`;
